import type { AddressCreateEditModel } from 'pos-shared/models/locationSchema.ts';

// only include state in payload if value entered
export const mapToLocationAddressPayload = (
  address: AddressCreateEditModel
) => {
  const addressPayload = {
    addressLine1: address.addressLine1,
    addressLine2: address.addressLine2,
    addressLine3: address.addressLine3,
    addressLine4: address.addressLine4,
    country: address.country,
    geoLocation: address.geoLocation,
    postalCode: address.postalCode,
    timeZone: address.timeZone,
  } as AddressCreateEditModel;

  if (address?.state?.length) {
    addressPayload.state = address.state;
  }

  return addressPayload;
};
